function getCapacitySource(target) {
  return target && target.closest ? target.closest('[data-capacity]') : null;
}

function isAllowedCapacitySource(source, allowedSelectors) {
  if (!source) return false;
  if (!allowedSelectors || !allowedSelectors.length) return true;

  return allowedSelectors.some((selector) => source.closest(selector));
}

export function getCapacityHoverValue(event, allowedSelectors = []) {
  const source = getCapacitySource(event.target);

  if (!source || !event.currentTarget.contains(source) || !isAllowedCapacitySource(source, allowedSelectors)) {
    return null;
  }

  return source.dataset.capacity || null;
}

export function getRelatedCapacityHoverValue(event, allowedSelectors = []) {
  const source = getCapacitySource(event.relatedTarget);

  if (!source || !event.currentTarget.contains(source) || !isAllowedCapacitySource(source, allowedSelectors)) {
    return null;
  }

  return source.dataset.capacity || null;
}
